export enum presentationType {
  bowtieListing = 5,
  riskMatrixListing = 6,
  caseReportTable = 7
}

export enum LayoutTypeValue {
  table = 1,
  tiles = 14,
  bowtie = 8
}

export const caseReportVisualisationTranslations = {
  visualisation: 7741,
  remove: 5913,
  move_down: 7538,
  move_up: 7743,
  drag_n_drop: 7740,
  title: 9375,
  add_new_fields: 9378,
  search_placeholder: 7345,
  add_new_fields_title: 3560,
  add_new_fields_done: 7338,
  select_all: 8420,
  clear_all: 8421
};

export enum reportCategory {
  caseReport = 1,
  actionReport = 2
}
